import React, { useEffect, useState } from 'react';
import ComplexText from '@ui/complex-text';
import HtmlList from '@ui/html-list';

const OptionBoxContent = ({ data }) => {
    return (
        <div className="text-sm">
            {data.title && (
                <h2 className="font-semibold text-base text-skin-dark">
                    {data.title}
                </h2>
            )}
            {data.text && <ComplexText values={data.text} />}
            <HtmlList type="image" className="mt-4" items={data.listItems} />
        </div>
    );
};

const OptionBoxRadioInput = ({ name, checked, onChange }) => {
    return (
        <div>
            <input
                type="radio"
                name={name}
                className="w-6 h-6 checked:bg-skin-primary focus:text-skin-primary focus:ring-primary focus:ring-2"
                onChange={onChange}
                checked={checked}
            />
        </div>
    );
};

const OptionBox = ({ data, name, checked, onChange }) => {
    const attributes = data.attributes ?? {};
    const borderCss = checked ? 'border-skin-primary' : 'border-skin-dark';
    return (
        <div {...attributes} className={`border ${borderCss} rounded-md p-5`}>
            <div className="flex gap-4">
                <OptionBoxRadioInput
                    data={data}
                    name={name}
                    checked={checked}
                    onChange={() => onChange(data)}
                />
                <OptionBoxContent data={data} />
            </div>
        </div>
    );
};

const OptionsContainer = ({ name, data, onChange }) => {
    if (!data.options) return null;

    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = (data) => {
        setSelectedOption(data);
        if (onChange)
            onChange({
                value: data.value,
                data: data.data ?? {},
            });
    };

    useEffect(() => {
        setSelectedOption(data.options?.find((x) => x.isSelected ?? false));
    }, []);

    return (
        <div className="flex flex-col gap-4">
            {data.options.map((opt, index) => {
                return (
                    <OptionBox
                        data={opt}
                        onChange={handleChange}
                        name={name}
                        key={index}
                        checked={opt.value === selectedOption?.value}
                    />
                );
            })}
        </div>
    );
};

const OptionsBoxRadio = ({ data, onChange }) => {
    return (
        <OptionsContainer data={data} onChange={onChange} name={data.name} />
    );
};

export default OptionsBoxRadio;
